<div class="alert-dialog-container">
  <div class="alert-dialog-content" [ngClass]="'alert-dialog-content--' + type" role="alertdialog" aria-modal="true">
    <div class="alert-dialog-orb alert-dialog-orb--one"></div>
    <div class="alert-dialog-orb alert-dialog-orb--two"></div>

    <div class="alert-dialog-chip">
      <i [class]="iconClass"></i>
      <span>{{ typeLabel }}</span>
    </div>

    <div class="alert-dialog-hero">
      <div class="alert-dialog-icon-shell">
        <div class="alert-dialog-icon-ring"></div>
        <div class="alert-dialog-icon-core">
          <i [class]="iconClass"></i>
        </div>
      </div>

      <div class="alert-dialog-copy">
        <h3>{{ title }}</h3>
        <p>{{ message | translateBackendMsg }}</p>
      </div>
    </div>

    <div class="alert-dialog-divider"></div>

    <div class="alert-dialog-footer" [class.alert-dialog-footer--single]="buttons.length <= 1">
      <button
        *ngFor="let btn of buttons"
        type="button"
        class="alert-dialog-btn"
        [ngClass]="getButtonVariant(btn)"
        (click)="onButtonClick(btn)"
      >
        <i *ngIf="btn.icon" [class]="btn.icon"></i>
        <span>{{ btn.text }}</span>
      </button>

      <button
        *ngIf="buttons.length === 0"
        type="button"
        class="alert-dialog-btn alert-dialog-btn--secondary"
        (click)="onClose()"
      >
        <span>Cerrar</span>
      </button>
    </div>
  </div>
</div>
